module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAyElEQVQ4T5XSAQ3CMBCF4X8KmAQkIGESJmEoAAngAAcgAQlIAAdIQAJ5SY9c11tHmzRruva7Xq8dZdsBmzT9Aj7Bmt9Ul0ZHYOsWa9MTOAH6p3HYDLgBU7CiB+41xABFUh+AA3B2UauIAG1SF6BoIzA/0SJigC7uAuirnB8J8VmFiAFaqE1rrUAE2KSOXi1Z0jPELtFSaEVGA4S3Iir72wMtiAUb5sA/SHbSCKghRZpLQISEd1QDPHIF9umVZqVeA4So7ooePrQvEv05YWoV/scAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/label.png
// module id = buk/
// module chunks = 1